import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router'

/**
 * `?seat=1` on a room URL (an accepted challenge) sits the player down as soon as the room is
 * known, once, then drops the flag from the URL so a reload or a share never re-seats anyone.
 * Joins are idempotent on the server, so racing the first snapshot is harmless.
 */
export function useAutoSeat(ready: boolean, seated: boolean, takeSeat: () => void) {
  const [params, setParams] = useSearchParams()
  const wanted = params.get('seat') === '1'
  const fired = useRef(false)
  useEffect(() => {
    if (!wanted || !ready || fired.current) return
    fired.current = true
    if (!seated) takeSeat()
    const next = new URLSearchParams(params)
    next.delete('seat')
    setParams(next, { replace: true })
  }, [wanted, ready, seated, takeSeat, params, setParams])
}
